import { useMemo } from 'react';

import { UIPerpMarketConfig } from '@drift/common';
import { usePerpMarketsLookup } from './usePerpMarketsLookup';

export const usePerpMarketConfigs = () => {
	const perpMarkets = usePerpMarketsLookup();
	const perpMarketConfigs = useMemo(
		() => perpMarkets.map((market) => new UIPerpMarketConfig(market)),
		[perpMarkets]
	);
	return perpMarketConfigs;
};
